import React, { useEffect, useState } from 'react'
import Breadcrumb from '../../../shared/components/atoms/breadcrumb/breadcrumb';
import { localStorage } from '../../../shared/utils/storage'
import ProductServices from '../../../services/product-services'
import SectionProductBanner from '../../molecules/section-product-banner/section-product-banner';
import SectionProductFeatures from '../../molecules/section-product-features/section-product-features';
import SectionProductStamps from '../../molecules/section-product-stamps/section-product-stamps';
import SectionDiaperCovers from '../../molecules/section-diaper-covers/section-diaper-covers';
import SectionOtherRecommendations from '../../molecules/section-other-recommendations/section-other-recommendations';
import SectionClubInvitation from '../../molecules/section-club-invitation/section-club-invitation';
import SectionPresentations from '../../molecules/section-presentations/section-presentations';
import SectionProductQualify from '../../molecules/section-product-qualify/section-product-qualify';
import SectionBuyIn from '../../molecules/section-buy-in/section-buy-in';
import { Parallax, Background } from 'react-parallax'
import useHaveClubPeque from '../../../shared/hooks/useHaveClubPeque'
import './product-internal-content.scss'

const ProductInternalContent = ({ contentInfo, clubData, alliesData }) => {

    const [productStage, setProductStage] = useState(0);
    const [productRating, setProductRating] = useState(null)
    const [activeModal, setActiveModal] = useState(null);
    const toRate = getParameterByName('toRate')
    const {haveClubPeque} = useHaveClubPeque()
    
    useEffect(() => {
        let payload = contentInfo.idDelProducto.toString() + "/" + process.env.COUNTRY_CODE
        const tokenInfo = localStorage.getItem("TOKEN_INFO") ? localStorage.getItem("TOKEN_INFO") : null
        let config = {
            headers: {
                Authorization: tokenInfo ? tokenInfo.idToken : null,
            },
        }

        ProductServices.rateProductId(tokenInfo ? config : null, payload).then(
            response => {
                if (response.status === 200) {
                    setProductRating(response.data ? response.data : { averageRate: 0, countRate: 0, rate: 1 })
                    if (toRate) {
                        window.scroll(0, ((findPos(document.getElementById("f-m-productQualify"))) - 150));
                    }
                }
            }
        )



    }, []);

    function getParameterByName(name) {
        name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
        let url_string = typeof window !== 'undefined' ? window.location.href : '/';
        let regex = new RegExp("[\\?&]" + name + "=([^?&#/]*)"),
            results = regex.exec(url_string);
        return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
    }

    function findPos(obj) {
        var curtop = 0;
        if (obj.offsetParent) {
            do {
                curtop += obj.offsetTop;
            } while (obj = obj.offsetParent);
            return [curtop];
        }
    }

    return (
        <div className="f-o-product-internal">
            <Parallax
                className="f-o-product-internal__parallax"
                strength={-1500}>
                <Background className="custom-bg">
                </Background>
            </Parallax>
            <Breadcrumb />
            {activeModal && <>{activeModal}</>}
            <SectionProductBanner contentInfo={contentInfo} productStage={productStage} setProductStage={setProductStage} productRating={productRating} />
            <SectionProductFeatures contentInfo={contentInfo} />
            {/* {contentInfo.categoria[0].idCategoria === "panales/" && <SectionDiaperCovers contentInfo={contentInfo} productStage={productStage} setProductStage={setProductStage} />} */}
            <SectionProductStamps contentInfo={contentInfo} />
            <SectionPresentations contentInfo={contentInfo} productStage={productStage} setProductStage={setProductStage} />
            {productRating && <SectionProductQualify contentInfo={contentInfo} rateUser={productRating.rate} id="f-m-productQualify" />}
            {contentInfo.otrasRecomendaciones && <SectionOtherRecommendations contentInfo={contentInfo} />}
            { haveClubPeque && <SectionClubInvitation clubData={clubData} setActiveModal={setActiveModal} />}
            <SectionBuyIn alliesData={alliesData} />
        </div>
    )
}

export default ProductInternalContent
